<template>
    <rkm-modal
        :buttons="['cancel']"
        :loading="loading"
        :title="title"
        large
        ref="Modal"
    >
        <template v-if="area">
            <rkm-alert
                v-if="(isTipoEsb(area) && !limiteHorasEsbAtingido) || (isTipoEmulti(area) && !isLimiteMininaAreaDaModalidadeAtingido)"
                color="danger"
            >
                A área não tem as equipes vinculadas exigidas para a carga horária ou a modalidade.
            </rkm-alert>

            <rkm-form
                ref="Form"
                show-legend
            >
                <rkm-row>
                    <rkm-col>
                        <rkm-form-select
                            :disabled="disableForm"
                            :options="areasDisponiveis"
                            :validations="validations.area"
                            label="Área"
                            show-default-option
                            textField="descricao"
                            v-model="model.areaId"
                            valueField="id"
                        />
                    </rkm-col>

                    <rkm-col cols="auto">
                        <rkm-button
                            :disabled="disableForm"
                            :label="false"
                            @click="$refs.Form.validate(add)"
                            color="primary"
                        >
                            Incluir
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>

            <rkm-table
                :fields="fields"
                :items="area.areasVinculadas"
                ref="Table"
            >
                <template v-slot:cell(actions)="{ item }">
                    <rkm-button
                        @click="handleDestroy(item)"
                        color="danger"
                        small
                        title="Excluir"
                    >
                        <rkm-icon icon="trash"/>
                    </rkm-button>
                </template>
            </rkm-table>
        </template>
    </rkm-modal>
</template>

<script>
// Vuex.
import { mapGetters } from 'vuex'

// Enums.
import areaTipo from '@/enums/atencao-basica/parametrizacao/areaTipo'
import areaModalidade from '@/enums/atencao-basica/parametrizacao/areaModalidade'
import areaCargaHoraria from '@/enums/atencao-basica/parametrizacao/areaCargaHoraria'

export default {
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        validations() {
            return {
                area: { required: true },
            }
        },
        fields() {
            return [
                { key: 'areaDescricao', label: 'Descrição', sortable: true, },
                { key: 'actions', label: 'Ações', class: 'col-min text-center', },
            ]
        },
        title() {
            if (!this.area) {
                return ''
            }

            const parts = []

            if (this.area.tipoSigla) parts.push(`Tipo: ${this.area.tipoSigla}`)
            if (this.area.descricao) parts.push(`Área: ${this.area.descricao}`)
            if (this.area.numeroIne) parts.push(`INE: ${this.area.numeroIne}`)
            if (this.area.cargaHorariaNome) parts.push(this.area.cargaHorariaNome)
            if (this.area.modalidadeNome) parts.push(this.area.modalidadeNome)

            return `Áreas vinculadas - (${parts.join(' - ')})`
        },
        disableForm() {
            return this.isTipoEsb(this.area) && this.limiteHorasEsbAtingido
        },
        areasDisponiveis() {
            let areas = []

            if (this.isTipoEsb(this.area)) {
                areas = this.areasDisponiveisParaEsb
            }
            else if (this.isTipoEmulti(this.area)) {
                areas = this.areasDisponiveisParaEmulti
            }

            return areas
                .filter(a => !this.area.areasVinculadas.some(av => av.areaId === a.id))
                .sort((a, b) => {
                    if (a.descricao === b.descricao) {
                        return 0
                    }
                    else if (a.descricao === null) {
                        return -1
                    }
                    else if (b.descricao === null) {
                        return 1
                    }

                    return parseInt(a.descricao) - parseInt(b.descricao)
                })
                .map(area => {
                    const parts = []

                    if (area.descricao) parts.push(`Área: ${area.descricao}`)
                    if (area.numeroIne) parts.push(`INE: ${area.numeroIne}`)
                    if (area.tipoSigla) parts.push(`Tipo: ${area.tipoSigla}`)

                    return {
                        id: area.id,
                        descricao: parts.join(' - ')
                    }
                })
        },
        areasDisponiveisParaEsb() {
            if (this.limiteHorasEsbAtingido) {
                return []
            }

            const areas = this.data.model.area.areas.filter(a => a.id !== this.area.id)
            const areasEsb = areas.filter(a => this.isTipoEsb(a))
            const areasSalvas = areas.filter(a => a.isSaved)

            if (this.isVinteHoras(this.area)) {
                return areasSalvas.filter(area => {
                    if (this.isTipoEsf(area)) {
                        if (!areasEsb.some(a => this.isAreaVinculada(a, area.id))
                            || areasEsb.filter(a => this.isVinteHoras(a) && this.isAreaVinculada(a, area.id)).length === 1
                        ) {
                            return true
                        }
                    }
                    else if (this.isTipoEap(area)) {
                        if (this.isVinteHoras(area)) {
                            return !areasEsb.some(a => this.isAreaVinculada(a, area.id))
                        }
                    }

                    return false
                })
            }
            else if (this.isTrintaHoras(this.area)) {
                return areasSalvas.filter(area => {
                    if (this.isTipoEap(area)) {
                        if (this.isTrintaHoras(area)) {
                            return !areasEsb.some(a => this.isAreaVinculada(a, area.id))
                        }
                    }

                    return false
                })
            }
            else if (this.isQuarentaHoras(this.area)) {
                if (this.hasAreaEapVinteHorasVinculada) {
                    return areasSalvas.filter(area => {
                        if (this.isTipoEap(area)) {
                            if (this.isVinteHoras(area)) {
                                return !areasEsb.some(a => this.isAreaVinculada(a, area.id))
                            }
                        }

                        return false
                    })
                }
                else {
                    return areasSalvas.filter(area => {
                        if (this.isTipoEsf(area)) {
                            return !areasEsb.some(a => this.isAreaVinculada(a, area.id))
                        }
                        else if (this.isTipoEap(area)) {
                            if (this.isVinteHoras(area)) {
                                return !areasEsb.some(a => this.isAreaVinculada(a, area.id))
                            }
                        }

                        return false
                    })
                }
            }

            return []
        },
        limiteHorasEsbAtingido() {
            if (this.isVinteHoras(this.area)) {
                if (this.hasAreaEsfVinculada || this.hasAreaEapVinteHorasVinculada) {
                    return true
                }
            }
            else if (this.isTrintaHoras(this.area)) {
                if (this.hasAreaEapTrintaHorasVinculada) {
                    return true
                }
            }
            else if (this.isQuarentaHoras(this.area)) {
                if (this.hasAreaEsfVinculada || this.quantidadeAreaEapVinteHorasVinculada === 2) {
                    return true
                }
            }

            return false
        },
        hasAreaEsfVinculada() {
            return this.area.areasVinculadas.some(av => this.isTipoEsf(this.getArea(av.areaId)))
        },
        hasAreaEapVinteHorasVinculada() {
            return this.area.areasVinculadas.some(av => {
                const area = this.getArea(av.areaId)

                return this.isTipoEap(area) && this.isVinteHoras(area)
            })
        },
        hasAreaEapTrintaHorasVinculada() {
            return this.area.areasVinculadas.some(av => {
                const area = this.getArea(av.areaId)

                return this.isTipoEap(area) && this.isTrintaHoras(area)
            })
        },
        hasAreaEapQuarentaHorasVinculada() {
            return this.area.areasVinculadas.some(av => {
                const area = this.getArea(av.areaId)

                return this.isTipoEap(area) && this.isQuarentaHoras(area)
            })
        },
        quantidadeAreaEapVinteHorasVinculada() {
            return this.area.areasVinculadas.filter(av => {
                const area = this.getArea(av.areaId)

                return this.isTipoEap(area) && this.isVinteHoras(area)
            }).length
        },
        areasDisponiveisParaEmulti() {
            const tipos = [
                this.enums.areaTipo.ESF,
                this.enums.areaTipo.ECR,
                this.enums.areaTipo.EAP,
            ]

            return this.data.model.area.areas.filter(area => area.isSaved
                && area.id !== this.area.id
                && tipos.includes(area.tipoId)
                && !this.data.model.area.areas.some(outraArea => this.isTipoEmulti(outraArea)
                    && outraArea.areasVinculadas.some(av => av.areaId === area.id))
            )
        },
        isLimiteAreaDaModalidadeAtingido() {
            return this.area.areasVinculadas.length === this.limiteAreasDaModalidade
        },
        limiteAreasDaModalidade() {
            switch (this.area.modalidadeId) {
                case this.enums.areaModalidade.AMPLIADA: return 12
                case this.enums.areaModalidade.COMPLEMENTAR: return 9
                case this.enums.areaModalidade.ESTRATEGICA: return 4
                default: return 0
            }
        },
        isLimiteMininaAreaDaModalidadeAtingido() {
            return this.area.areasVinculadas.length >= this.limiteMinimoAreasDaModalidade
        },
        limiteMinimoAreasDaModalidade() {
            switch (this.area.modalidadeId) {
                case this.enums.areaModalidade.AMPLIADA: return 10
                case this.enums.areaModalidade.COMPLEMENTAR: return 5
                case this.enums.areaModalidade.ESTRATEGICA: return 1
                default: return 0
            }
        }
    },
    data: () => ({
        area: null,
        model: {
            areaId: null,
        },
        enums: { areaTipo, areaModalidade, areaCargaHoraria }
    }),
    methods: {
        open(area) {
            this.area = area

            this.resetForm()

            this.$refs.Modal.show()
        },
        add() {
            if (this.isTipoEmulti(this.area) && this.isLimiteAreaDaModalidadeAtingido) {
                this.showValidationNotification('Limite máximo de áreas atingido')

                return
            }

            this.area.areasVinculadas.push({
                areaId: this.model.areaId,
                areaDescricao: this.areasDisponiveis.find(a => a.id === this.model.areaId).descricao,
            })

            this.resetForm()
        },
        resetForm() {
            this.model.areaId = null,

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        handleDestroy(areaVinculada) {
            const destroy = async () => {
                this.area.areasVinculadas.splice(this.area.areasVinculadas.indexOf(areaVinculada), 1)
            }

            this.showDeleteConfirmation('Deseja realmente excluir a área vinculada?', destroy, this.handleError)
        },
        getArea(areaId) {
            return this.data.model.area.areas.find(a => a.id === areaId)
        },
        isTipoEsb(area) {
            return area.tipoId === this.enums.areaTipo.ESB
        },
        isTipoEmulti(area) {
            return area.tipoId === this.enums.areaTipo.EMULTI
        },
        isTipoEap(area) {
            return area.tipoId === this.enums.areaTipo.EAP
        },
        isTipoEsf(area) {
            return area.tipoId === this.enums.areaTipo.ESF
        },
        isVinteHoras(area) {
            return area.cargaHorariaId === this.enums.areaCargaHoraria.VINTE_HORAS
        },
        isTrintaHoras(area) {
            return area.cargaHorariaId === this.enums.areaCargaHoraria.TRINTA_HORAS
        },
        isQuarentaHoras(area) {
            return area.cargaHorariaId === this.enums.areaCargaHoraria.QUARENTA_HORAS
        },
        isAreaVinculada(area, areaId) {
            return area.areasVinculadas.some(a => a.areaId === areaId)
        },
    },
    props: {
        data: { type: Object, required: true },
    }
}
</script>